module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/payment-c5ed0bd984e825b180f46ab4a3a034f0.png";